"use client";
import Breadcrumb from "@/components/BreadCrumb";
import VirtualPvEvent from "@/components/VirtualPvEvent";
import { DATA_LAYER_PAGE_NAMES } from "@/constants/dataLayer";
import { generateCampaignsPageBreadcrumb } from "@/utils/breadcrumbUtils";
import dynamic from "next/dynamic";
import CampaignTabs from "./CampaignTabs";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";

const CampaignsClientSection = dynamic(
  () => import("./CampaignsClientSection"),
  {
    ssr: true,
  },
);

function CampaignsPage({ locale, pageType, campaigns }) {
  const t = useTranslationDetector();
  const breadcrumbItems = generateCampaignsPageBreadcrumb(
    pageType,
    {},
    t,
    "campaigns",
    locale,
  );

  return (
    <div>
      <VirtualPvEvent pageType={DATA_LAYER_PAGE_NAMES.PROMOTIONS} />
      <section className="bg-background-global">
        <div className="container mx-auto mt-14 flex flex-col gap-6 py-6 pb-10 md:mt-0">
          <div className="mt-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className="flex flex-col gap-2">
            <h1 className="text-4xl/[45px] font-semibold">
              {t("campaigns.campaignsTitle")}
            </h1>
            <p className="text-foreground-muted text-base/[21px] font-normal">
              {t("campaigns.campaignsDescription")}
            </p>
          </div>
          <div>
            <CampaignTabs t={t} pageType={pageType} />
          </div>
        </div>
      </section>
      <CampaignsClientSection campaigns={campaigns} locale={locale} />
    </div>
  );
}

export default CampaignsPage;
